// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2t6Je","nav":"Header_nav__akIpU","navList":"Header_navList__dhkDJ","userSection":"Header_userSection__qItOH","stickyHeader":"Header_stickyHeader__-Xa4x"};